<div
  #ctaBtn
  data-id-cypress="'cta-actions"
  class="bary-cta-wrapper waves-effect text-center"
  (click)="onClick($event)"
  data-toggle="dropdown"
  aria-haspopup="true"
  aria-expanded="false"
  mdbWavesEffect
  [attr.data-id-cypress]="'cta-actions' + idCypress"
>
  <jhi-bary-icon icon="ellipsis-vertical" [faDirective]="FAS" size="lg"></jhi-bary-icon>
</div>
